import smoothscroll from 'smoothscroll-polyfill';
import 'url-search-params-polyfill';

require('@babel/polyfill');
require('./vendor/blob-polyfill');
require('isomorphic-fetch');
// kick off the polyfill!
smoothscroll.polyfill();

require('foundation-sites/dist/js/foundation');
require('foundation-sites/dist/js/plugins/foundation.accordion');
require('foundation-sites/dist/js/plugins/foundation.tabs');
require('foundation-sites/dist/js/plugins/foundation.reveal');
require('foundation-sites/dist/js/plugins/foundation.drilldown');
require('foundation-sites/dist/js/plugins/foundation.abide');
require('./pages/validator');
require('./vendor/jquery-ui.min');
require('./vendor/jquery-datepicker-nl');
require('./vendor/autohide-header');
require('./pages/all');
